import React, { useEffect, useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const FileUpload = ({ onFilesChange }) => {
  const [files, setFiles] = useState([]);
  const [themeVars, setThemeVars] = useState({});

  useEffect(() => {
    onFilesChange?.(files.map(f => f.file));
  }, [files]);

  useEffect(() => {
    const updateThemeVars = () => {
      const root = document.documentElement;
      setThemeVars({
        inputBg: getComputedStyle(root).getPropertyValue('--vz-input-bg-custom').trim(),
        bodyColor: getComputedStyle(root).getPropertyValue('--vz-body-color').trim(),
        borderColor: getComputedStyle(root).getPropertyValue('--vz-input-border-custom').trim(),
        primaryColor: getComputedStyle(root).getPropertyValue('--vz-primary').trim(),
      });
    };

    updateThemeVars();

    const observer = new MutationObserver(updateThemeVars);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme', 'class'],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const styleTagId = "filepond-theme-vars";
    let styleTag = document.getElementById(styleTagId);
    if (!styleTag) {
      styleTag = document.createElement("style");
      styleTag.id = styleTagId;
      document.head.appendChild(styleTag);
    }

    styleTag.innerHTML = `
      .filepond--root {
        background-color: ${themeVars.inputBg};
        color: ${themeVars.bodyColor};
      }
      .filepond--panel-root {
        background-color: ${themeVars.inputBg};
        border: 2px dashed ${themeVars.borderColor};
        border-radius: 6px;
      }
      .filepond--drop-label {
        color: ${themeVars.bodyColor};
        font-weight: 500;
      }
      .filepond--image-preview-wrapper {
        background-color: ${themeVars.inputBg};
      }
    `;
  }, [themeVars]);

  return (
    <FilePond
      files={files}
      onupdatefiles={setFiles}
      allowMultiple={true}
      maxFiles={3}
      name="files"
      className="filepond filepond-input-multiple"
    />
  );
};

export default FileUpload;
